@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}

<ws-modal-wrapper [headerLabel]="title"
                  [suppressKeyboardEvents]="true"
                  (save)="save()"
                  (cancel)="cancel()"
                  [disableSave]="!rowsSelected">
    @if (entityPicker) {
        <ws-ag-grid-angular [gridOptions]="gridOptions"
                            (gridReady)="onAgGridReady($event)">
        </ws-ag-grid-angular>
    }
    @if (entityPicker.optionFlagText) {
        <div class="ws-flex-container-horizontal modal-options">
            <div class="checkbox">
                <label>
                    <input type="checkbox"
                           [(ngModel)]="entityPicker.optionFlag"
                           (change)="entityPicker.optionFlagChange()">{{ entityPicker.optionFlagText }}
                </label>
            </div>
        </div>
    }
</ws-modal-wrapper>
